export const BRIEF_BLOCK_REASON_CODES = Object.freeze([
  'invalid_manifest',
  'invalid_profile',
  'invalid_audience_profile',
  'missing_evidence',
  'stale_evidence',
  'conflicting_evidence',
  'wrong_tenant',
  'wrong_scope',
  'forbidden_source_class',
  'unsupported_source_class',
  'insufficient_permission',
  'low_confidence',
  'low_proof_level',
  'config_registry_unavailable',
  'profile_provider_unavailable',
  'evidence_provider_unavailable',
  'profile_load_failed',
  'evidence_load_failed',
  'unsupported_brief_type',
  'audience_profile_not_found',
  'profile_not_supported',
  'invalid_brief_spec',
  'unsupported_section',
  'unsupported_evidence_ref',
  'synthesis_failed',
  'missing_registration',
  'unpromoted_registration',
  'retired_registration',
  'invalid_registration',
  'missing_eval_promotion_proof',
  'evidence_values_not_allowed',
] as const);

export type BriefBlockReasonCode = (typeof BRIEF_BLOCK_REASON_CODES)[number];
